import { motion } from "framer-motion";
import Headline from "../shared/Headline";
import { frontendSkills, backendSkills, tools } from "../skills";

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { staggerChildren: 0.05 },
  },
};

const item = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0, transition: { duration: 0.4 } },
};

const SkillCard = ({ skill, index }) => (
  <motion.div
    variants={item}
    className="group relative"
  >
    <div className="card-hover flex flex-col items-center text-center gap-3 rounded-xl">
      <div className="text-4xl transition-transform duration-300 group-hover:scale-110 group-hover:-translate-y-1">
        {skill.icon}
      </div>
      <p className="text-sm font-medium text-gray-300 group-hover:text-white transition-colors">
        {skill.title}
      </p>
    </div>
  </motion.div>
);

const SkillSection = ({ title, skills }) => (
  <div>
    <h3 className="text-xl font-bold text-white mb-8 flex items-center gap-3">
      <span className="w-8 h-0.5 bg-primary-500 rounded-full" />
      {title}
      <span className="text-sm text-gray-500 font-normal">({skills.length})</span>
    </h3>
    <motion.div
      variants={container}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.1 }}
      className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3"
    >
      {skills.map((skill, i) => (
        <SkillCard key={skill.id} skill={skill} index={i} />
      ))}
    </motion.div>
  </div>
);

const Skills = () => {
  return (
    <section id="skills" className="px-6 relative">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(99,102,241,0.05),transparent_70%)]" />
      <div className="container-custom relative">
        <Headline
          title="Skills & Technologies"
          subtitle="Tools and technologies I use to bring ideas to life."
        />
        <div className="flex flex-col gap-16">
          <SkillSection title="Frontend" skills={frontendSkills} />
          <SkillSection title="Backend & Database" skills={backendSkills} />
          <SkillSection title="DevOps & Tools" skills={tools} />
        </div>
      </div>
    </section>
  );
};

export default Skills;
